import React, { useState } from "react";
import {
  Container,
  Box,
  Typography,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Button,
  Grid,
} from "@mui/material";
import axios from "axios";
import Navbar from "../../Navbar/Navbar";
import { countries } from 'countries-list';
import { useNavigate } from "react-router-dom";
import baseURL from "../../config";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css';


const VesselOwnerForm = () => {
  const [formData, setFormData] = useState({
    company_name: "",
    companyDocument: null,
    company_shortname: "",
    phoneno: "",
    cperson_prefix: "MR.",
    contactperson: "",
    email: "",
    address: "",
    companyPAN: "",
    companyGST: "",
    companyVAT: "",
    panCardDocument: null,
    gstDocument: null,
    vatDocument: null,
    country: "India",
    accounts_department1: "MR.",
    accounts_department11: "",
    phoneaccounts_department1: "",
    accountsEmail: "",
    anotherAccountsTitle: "MR.",
    anotherAccountsPersonName: "",
    anotherAccountsPhoneNumber: "",
    anotherAccountsEmail: "",
  });

  const navigate = useNavigate();
  const [phoneFocused, setPhoneFocused] = useState(false);
  const [phoneAccountsFocused, setPhoneAccountsFocused] = useState(false);
  const [phoneFocuseduser, setPhoneFocuseduser] = useState(false);


  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // If company_name is being changed, also set short name
    if (name === "company_name") {
      const words = value.trim().split(/\s+/);
      const shortName = words.map(word => word[0]?.toUpperCase()).join('');

      setFormData((prevData) => ({
        ...prevData,
        company_name: value,
        company_shortname: shortName,
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };


  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: files[0] || null,
    }));
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  const formDataToSend = new FormData();
  for (const key in formData) {
    if (
      formData[key] !== null &&
      formData[key] !== "" &&
      formData[key] !== undefined
    ) {
      formDataToSend.append(key, formData[key]);
    }
  }

  const token = localStorage.getItem("token");
  try {
    const response = await axios.post(
      `${baseURL}/api/vesselOwnerform`,
      formDataToSend,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.status === 200 || response.status === 201) {
      toast.success("Form submitted successfully!");
      setTimeout(() => {
        navigate("/login");
      }, 2000);
    }
  } catch (err) {
    console.error("Error submitting form:", err);

    if (err.response) {
      // Validation error from backend
      if (err.response.status === 400 && err.response.data.errors) {
        err.response.data.errors.forEach((msg) => {
          toast.error(msg); // Show each validation error
        });
      } else {
        toast.error(err.response.data.message || "An error occurred");
      }
    } else {
      toast.error("Network error. Please try again.");
    }
  }
};



  const countryList = Object.entries(countries).map(([code, country]) => ({
    code,
    name: country.name,
  }));

  const getCountryCode = (countryName) => {
    const entry = Object.entries(countries).find(
      ([code, data]) => data.name.toLowerCase() === countryName.toLowerCase()
    );
    return entry ? entry[0].toLowerCase() : "in"; // fallback to India
  };

  return (
    <>
      <Navbar />
      <Typography variant="h4" align="center" gutterBottom color="#C30B12" sx={{ marginTop: "0.5rem" }}>
        Vessel Owner Form
      </Typography>
      <Container
        maxWidth="md"
        sx={{
          mt: 4,
          mb: 4,
          p: 4,
          border: "2px solid #C30B12",
          borderRadius: 3,
          boxShadow: 3,
          backgroundColor: "#f9f9f9",
        }}
      >
        <Typography variant="h4" align="center" gutterBottom color="#C30B12">
          Add Company Details
        </Typography>

        <Box component="form" onSubmit={handleSubmit} noValidate>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <FormControl fullWidth
                sx={{
                  '& .MuiOutlinedInput-root': { '&.Mui-focused fieldset': { borderColor: '#C30B12', }, },
                  '& .MuiInputLabel-root.Mui-focused': { color: '#C30B12', },
                }}>
                <InputLabel>Location of Company *</InputLabel>
                <Select
                  name="country"
                  value={formData.country}
                  onChange={handleInputChange}
                >
                  {countryList.map((country) => (
                    <MenuItem key={country.code} value={country.name}>
                      {country.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Company Name"
                name="company_name"
                value={formData.company_name}
                onChange={handleInputChange}
                required
                sx={{
                  '& .MuiOutlinedInput-root': { '&.Mui-focused fieldset': { borderColor: '#C30B12', }, },
                  '& .MuiInputLabel-root.Mui-focused': { color: '#C30B12', },
                }}
              />
            </Grid>

            {/* Company Registration Document Upload */}
            <Grid item xs={12}>
              <Button
                variant="contained"
                component="label"
                fullWidth
                startIcon={<UploadFileIcon />}
                sx={{
                  justifyContent: "flex-start",
                  textTransform: "none",
                  padding: 2,
                  backgroundColor: "#C30B12",
                  color: "#fff",
                }}
              >
                <input
                  hidden
                  type="file"
                  name="companyDocument"
                  onChange={handleFileChange}
                />
                <Typography variant="body1" noWrap>
                  {formData.companyDocument
                    ? formData.companyDocument.name
                    : "Upload Company Registration Document *"}
                </Typography>
              </Button>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Company Short Name"
                name="company_shortname"
                value={formData.company_shortname}
                onChange={handleInputChange}
                sx={{
                  '& .MuiOutlinedInput-root': { '&.Mui-focused fieldset': { borderColor: '#C30B12', }, },
                  '& .MuiInputLabel-root.Mui-focused': { color: '#C30B12', },
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>

              <FormControl fullWidth variant="outlined">
                <InputLabel
                  shrink
                  htmlFor="phoneno"
                  sx={{
                    color: phoneFocuseduser ? '#C30B12' : 'inherit',
                  }}
                >
                  Phone Number *
                </InputLabel>

                <PhoneInput
                  country={getCountryCode(formData.country)}
                  value={formData.phoneno}
                  onChange={(value, country) => {
                    const dialCode = country?.dialCode || '';
                    const numberWithoutCode = value.slice(dialCode.length);
                    const formattedNumber = `+${dialCode} ${numberWithoutCode}`;

                    setFormData((prev) => ({ ...prev, phoneno: formattedNumber }));
                  }}
                  onFocus={() => setPhoneFocuseduser(true)}
                  onBlur={() => setPhoneFocuseduser(false)}
                  placeholder="Add phone number *"
                  inputProps={{
                    name: 'phoneno',
                    id: 'phoneno',
                  }}
                  inputStyle={{
                    width: '100%',
                    height: '56px',
                    fontSize: '16px',
                    paddingLeft: '48px',
                    borderRadius: '4px',
                    border: phoneFocuseduser
                      ? '2px solid #C30B12'
                      : '1px solid rgba(0, 0, 0, 0.23)',
                    boxShadow: phoneFocuseduser ? '0 0 0 1px #C30B12' : 'none',
                  }}
                  buttonStyle={{
                    border: 'none',
                    background: 'transparent',
                  }}
                  containerStyle={{
                    width: '100%',
                  }}
                />
              </FormControl>

            </Grid>

            {/* Contact Person */}
            <Grid item xs={12} sm={3}>
              <FormControl fullWidth
                sx={{
                  '& .MuiOutlinedInput-root': { '&.Mui-focused fieldset': { borderColor: '#C30B12', }, },
                  '& .MuiInputLabel-root.Mui-focused': { color: '#C30B12', },
                }}
              >
                <InputLabel>Prefix</InputLabel>
                <Select
                  name="cperson_prefix"
                  value={formData.cperson_prefix}
                  label="Prefix *"
                  onChange={handleInputChange}
                >
                  <MenuItem value="MR.">MR.</MenuItem>
                  <MenuItem value="MRS.">MRS.</MenuItem>
                  <MenuItem value="MISS">MISS</MenuItem>
                  <MenuItem value="Capt">Capt.</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={9}>
              <TextField
                fullWidth
                label="Authorised Person Name *"
                name="contactperson"
                value={formData.contactperson}
                onChange={handleInputChange}
                sx={{
                  '& .MuiOutlinedInput-root': { '&.Mui-focused fieldset': { borderColor: '#C30B12', }, },
                  '& .MuiInputLabel-root.Mui-focused': { color: '#C30B12', },
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Email ID *"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleInputChange}
                sx={{
                  '& .MuiOutlinedInput-root': { '&.Mui-focused fieldset': { borderColor: '#C30B12', }, },
                  '& .MuiInputLabel-root.Mui-focused': { color: '#C30B12', },
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                multiline
                rows={3}
                label="Address"
                name="address"
                value={formData.address}
                onChange={handleInputChange}
                sx={{
                  '& .MuiOutlinedInput-root': { '&.Mui-focused fieldset': { borderColor: '#C30B12', }, },
                  '& .MuiInputLabel-root.Mui-focused': { color: '#C30B12', },
                }}
              />
            </Grid>

            {/* Company PAN and PAN Card Upload */}
            <Grid item xs={12}>
              <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                <TextField
                  required
                  label="Company PAN"
                  name="companyPAN"
                  value={formData.companyPAN}
                  onChange={handleInputChange}
                  sx={{
                    width: '48%',
                    '& .MuiOutlinedInput-root': { '&.Mui-focused fieldset': { borderColor: '#C30B12', }, },
                    '& .MuiInputLabel-root.Mui-focused': { color: '#C30B12', },
                  }}
                />
                <Button
                  variant="contained"
                  component="label"
                  startIcon={<UploadFileIcon />}
                  sx={{
                    width: '48%',
                    justifyContent: "flex-start",
                    textTransform: "none",
                    padding: 2,
                    backgroundColor: "#C30B12",
                    color: "#fff",
                  }}
                >
                  <input hidden type="file" name="panCardDocument" onChange={handleFileChange} required />
                  <Typography variant="body1" noWrap>
                    {formData.panCardDocument
                      ? formData.panCardDocument.name
                      : "Upload PAN Card Document *"}
                  </Typography>
                </Button>
              </Box>
            </Grid>

            {/* Company GST and GST Upload */}
            <Grid item xs={12}>
              <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                <TextField
                  required
                  sx={{
                    width: '48%',
                    '& .MuiOutlinedInput-root': { '&.Mui-focused fieldset': { borderColor: '#C30B12', }, },
                    '& .MuiInputLabel-root.Mui-focused': { color: '#C30B12', },
                  }}
                  label="Company GST"
                  name="companyGST"
                  value={formData.companyGST}
                  onChange={handleInputChange}
                />
                <Button
                  variant="contained"
                  component="label"
                  startIcon={<UploadFileIcon />}
                  sx={{
                    width: '48%',
                    justifyContent: "flex-start",
                    textTransform: "none",
                    padding: 2,
                    backgroundColor: "#C30B12",
                    color: "#fff",
                  }}
                >
                  <input hidden type="file" name="gstDocument" onChange={handleFileChange} required />
                  <Typography variant="body1" noWrap>
                    {formData.gstDocument
                      ? formData.gstDocument.name
                      : "Upload GST Document *"}
                  </Typography>
                </Button>
              </Box>
            </Grid>

            {/* Company VAT and VAT Upload */}
            <Grid item xs={12}>
              <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                <TextField
                  required
                  sx={{
                    width: '48%',
                    '& .MuiOutlinedInput-root': { '&.Mui-focused fieldset': { borderColor: '#C30B12', }, },
                    '& .MuiInputLabel-root.Mui-focused': { color: '#C30B12', },
                  }}
                  label="Company VAT"
                  name="companyVAT"
                  value={formData.companyVAT}
                  onChange={handleInputChange}
                  type="number"
                  inputProps={{ min: 0 }}
                />
                <Button
                  variant="contained"
                  component="label"
                  startIcon={<UploadFileIcon />}
                  sx={{
                    width: '48%',
                    justifyContent: "flex-start",
                    textTransform: "none",
                    padding: 2,
                    backgroundColor: "#C30B12",
                    color: "#fff",
                  }}
                >
                  <input hidden type="file" name="vatDocument" onChange={handleFileChange} required />
                  <Typography variant="body1" noWrap>
                    {formData.vatDocument
                      ? formData.vatDocument.name
                      : "Upload VAT Document *"}
                  </Typography>
                </Button>
              </Box>
            </Grid>



            {/* Country */}

            <Grid item xs={12}>
              <Typography variant="h5" gutterBottom>
                Name of Accounting Team Personnel
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant="subtitle1"
                gutterBottom
                sx={{ fontWeight: 'bold', color: '#C30B12' }}
              >
                Primary Accounts Contact
              </Typography>
            </Grid>

            {/* Accounts Department Person 1 */}
            <Grid item xs={12} sm={3}>
              <FormControl fullWidth
                sx={{
                  '& .MuiOutlinedInput-root': { '&.Mui-focused fieldset': { borderColor: '#C30B12', }, },
                  '& .MuiInputLabel-root.Mui-focused': { color: '#C30B12', },
                }}>
                <InputLabel>Prefix</InputLabel>
                <Select
                  name="accounts_department1"
                  value={formData.accounts_department1}
                  label="Prefix"
                  onChange={handleInputChange}

                >
                  <MenuItem value="MR.">MR.</MenuItem>
                  <MenuItem value="MRS.">MRS.</MenuItem>
                  <MenuItem value="MISS">MISS.</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={9}>
              <TextField
                fullWidth
                label="Name of Person in Accounts Department"
                name="accounts_department11"
                value={formData.accounts_department11}
                onChange={handleInputChange}
                sx={{
                  '& .MuiOutlinedInput-root': { '&.Mui-focused fieldset': { borderColor: '#C30B12', }, },
                  '& .MuiInputLabel-root.Mui-focused': { color: '#C30B12', },
                }}
              />
            </Grid>

            {/* Phone and Email Accounts Department */}
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth variant="outlined" style={{ marginBottom: '1rem' }}>
                <InputLabel
                  shrink
                  htmlFor="phoneaccounts_department1"
                  sx={{
                    color: phoneAccountsFocused ? '#C30B12' : 'inherit',
                  }}
                >
                  Phone Number
                </InputLabel>

                <PhoneInput
                  country={'in'}
                  value={formData.phoneaccounts_department1}
                  onFocus={() => setPhoneAccountsFocused(true)}
                  onBlur={() => setPhoneAccountsFocused(false)}
                  onChange={(value, country) => {
                    const dialCode = country?.dialCode || '';
                    const numberWithoutCode = value.slice(dialCode.length);
                    const formattedNumber = `+${dialCode} ${numberWithoutCode}`;

                    setFormData((prev) => ({
                      ...prev,
                      phoneaccounts_department1: formattedNumber,
                    }));
                  }}
                  inputProps={{
                    name: 'phoneaccounts_department1',
                    id: 'phoneaccounts_department1',
                  }}
                  inputStyle={{
                    width: '100%',
                    height: '56px',
                    fontSize: '16px',
                    paddingLeft: '48px',
                    borderRadius: '4px',
                    border: phoneAccountsFocused
                      ? '2px solid #C30B12'
                      : '1px solid rgba(0, 0, 0, 0.23)',
                    boxShadow: phoneAccountsFocused ? '0 0 0 1px #C30B12' : 'none',
                  }}
                  buttonStyle={{
                    border: 'none',
                    background: 'transparent',
                  }}
                  containerStyle={{
                    width: '100%',
                  }}
                />

              </FormControl>

            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Email"
                name="accountsEmail"
                value={formData.accountsEmail}
                onChange={handleInputChange}
                type="email"
                sx={{
                  '& .MuiOutlinedInput-root': { '&.Mui-focused fieldset': { borderColor: '#C30B12', }, },
                  '& .MuiInputLabel-root.Mui-focused': { color: '#C30B12', },
                }}
              />
            </Grid>

            {/* Another Accounts Department Person */}
            <Grid item xs={12} sx={{ mt: 2 }}>
              <Typography
                variant="subtitle1"
                gutterBottom
                sx={{ fontWeight: 'bold', color: '#C30B12' }}
              >
                Secondary Accounts Contact
              </Typography>
            </Grid>
            <Grid item xs={12} sm={3}>
              <FormControl fullWidth
                sx={{
                  '& .MuiOutlinedInput-root': { '&.Mui-focused fieldset': { borderColor: '#C30B12', }, },
                  '& .MuiInputLabel-root.Mui-focused': { color: '#C30B12', },
                }}>
                <InputLabel>Prefix</InputLabel>
                <Select
                  name="anotherAccountsTitle"
                  value={formData.anotherAccountsTitle}
                  label="Prefix"
                  onChange={handleInputChange}
                >
                  <MenuItem value="MR.">MR.</MenuItem>
                  <MenuItem value="MRS.">MRS.</MenuItem>
                  <MenuItem value="MISS">MISS</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={9}>
              <TextField
                fullWidth
                label="Name of Another Person in Accounts Department"
                name="anotherAccountsPersonName"
                value={formData.anotherAccountsPersonName}
                onChange={handleInputChange}
                sx={{
                  '& .MuiOutlinedInput-root': { '&.Mui-focused fieldset': { borderColor: '#C30B12', }, },
                  '& .MuiInputLabel-root.Mui-focused': { color: '#C30B12', },
                }}
              />
            </Grid>

            {/* Phone and Email Another Accounts Department */}
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth variant="outlined" style={{ marginBottom: '1rem' }}>
                <InputLabel
                  shrink
                  htmlFor="anotherAccountsPhoneNumber"
                  sx={{
                    color: phoneFocused ? '#C30B12' : 'inherit',
                  }}
                >
                  Phone Number
                </InputLabel>

                <PhoneInput
                  country={'in'}
                  value={formData.anotherAccountsPhoneNumber}
                  onFocus={() => setPhoneFocused(true)}
                  onBlur={() => setPhoneFocused(false)}
                  onChange={(value, country) => {
                    const dialCode = country.dialCode;
                    const numberWithoutCode = value.slice(dialCode.length);
                    const formattedNumber = `+${dialCode} ${numberWithoutCode}`;

                    setFormData((prev) => ({
                      ...prev,
                      anotherAccountsPhoneNumber: formattedNumber,
                    }));
                  }}
                  inputProps={{
                    name: 'anotherAccountsPhoneNumber',
                    id: 'anotherAccountsPhoneNumber',
                  }}
                  inputStyle={{
                    width: '100%',
                    height: '56px',
                    fontSize: '16px',
                    paddingLeft: '48px',
                    borderRadius: '4px',
                    border: phoneFocused
                      ? '1px solid #C30B12'
                      : '1px solid rgba(0, 0, 0, 0.23)',
                    boxShadow: phoneFocused ? '0 0 0 1px #C30B12' : 'none',
                  }}
                  buttonStyle={{
                    border: 'none',
                    background: 'transparent',
                  }}
                  containerStyle={{
                    width: '100%',
                  }}
                />
              </FormControl>

            </Grid>


            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Email"
                name="anotherAccountsEmail"
                value={formData.anotherAccountsEmail}
                onChange={handleInputChange}
                type="email"
                sx={{
                  '& .MuiOutlinedInput-root': { '&.Mui-focused fieldset': { borderColor: '#C30B12', }, },
                  '& .MuiInputLabel-root.Mui-focused': { color: '#C30B12', },
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Button
                variant="contained"
                type="submit"
                fullWidth
                sx={{ mt: 3, backgroundColor: "#D4AF37" }}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Container>
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
};

export default VesselOwnerForm;
